import { Comment } from 'src/api/comments';
import { FileMediaLinks, Pagination } from 'src/api/common';
import api from './baseApi';
import { PostWithEngagementMetrics } from './user';

export interface Challenge {
  _id: string;
  name: string;
  category: string;
}

export enum PostStatus {
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  REMOVED = 'REMOVED',
}

export interface Post {
  _id: string;
  createdAt: string;
  updatedAt: string;

  status: PostStatus;

  tribe_id: string;
  tribe_name: string;
  leader_id: string;
  leader_name: string;

  video_id: string;
  video: FileMediaLinks;
  video_url: string; // TODO: DEPRECATE video_url
  challenges: Challenge[];
  comments: Comment[];

  comment_count: number;
  unread_comment_count: number;
}

export interface PostsResponse {
  result: PostWithEngagementMetrics[];
  pagination: Pagination;
}

export interface CommentsForPostResponse {
  result: Comment[];
  children: Comment[][];
  pagination: Pagination;
}

export const postsApi = {
  getPostsForCircle: async (
    id: string,
    page: number,
    signal?: AbortSignal
  ): Promise<PostsResponse> => {
    const axiosResponse = await api.get(`posts/?tribe_id=${id}&page=${page}`, {
      signal,
    });
    return axiosResponse.data;
  },

  getSelectedPost: async (id: string, signal?: AbortSignal): Promise<Post> => {
    const axiosResponse = await api.get(`posts/${id}`, { signal });
    return axiosResponse.data.result;
  },

  getCommentsForPost: async (
    postId: string,
    page = 1,
    pageSize = 10
  ): Promise<CommentsForPostResponse> => {
    const axiosResponse = await api.get(
      `posts/${postId}/comments?page=${page}&pageSize=${pageSize}`
    );
    return axiosResponse.data;
  },

  createPost: async (
    tribe_id: string,
    data: {
      video_id: string;
      challenges: { name: string; category: string }[];
    }
  ): Promise<Post> => {
    const axiosResponse = await api.post(`/tribes/${tribe_id}/posts`, {
      ...data,
    });

    return axiosResponse.data.result;
  },
};
